import {
  ReadingStatus,
  ReadingTemplateRoles,
  ReadingType,
} from 'infrastructure/enums';

import { freeTextBlurb } from './helpers';
import * as maGreenBlurbs from './ma-green';
import * as maYellowBlurbs from './ma-yellow';
import * as nurseYellowBlurbs from './nurse-yellow';
import {
  type TMaBlurbGreenFnMap,
  type TMaBlurbYellowFnMap,
  type TNurseBlurbYellowFnMap,
  type TNurseStatusBlurbFnMap,
  type TNurseBlurbGreenFnMap,
  type TMaStatusBlurbFnMap,
  type TRoleBlurbFnMap,
} from '../types';

export const generateMaGreenBlurbs: TMaBlurbGreenFnMap = {
  [ReadingType.BloodPressure]: maGreenBlurbs.bloodPressure,
  [ReadingType.SpO2]: maGreenBlurbs.spo2,
  [ReadingType.BloodGlucose]: maGreenBlurbs.glucose,
  [ReadingType.Weight]: maGreenBlurbs.weight,
  [ReadingType.PeakFlow]: freeTextBlurb,
  [ReadingType.SleepingMat]: freeTextBlurb,
  [ReadingType.Temperature]: freeTextBlurb,
  [ReadingType.Pulse]: freeTextBlurb,
};
export const generateMaYellowBlurbs: TMaBlurbYellowFnMap = {
  [ReadingType.BloodPressure]: maYellowBlurbs.bloodPressure,
  [ReadingType.SpO2]: maYellowBlurbs.spo2,
  [ReadingType.BloodGlucose]: maYellowBlurbs.glucose,
  [ReadingType.Weight]: maYellowBlurbs.weight,
  [ReadingType.PeakFlow]: freeTextBlurb,
  [ReadingType.SleepingMat]: freeTextBlurb,
  [ReadingType.Temperature]: freeTextBlurb,
  [ReadingType.Pulse]: freeTextBlurb,
};

export const generateNurseGreenBlurbs: TNurseBlurbGreenFnMap = {
  [ReadingType.BloodPressure]: maGreenBlurbs.bloodPressure,
  [ReadingType.SpO2]: maGreenBlurbs.spo2,
  [ReadingType.BloodGlucose]: maGreenBlurbs.glucose,
  [ReadingType.Weight]: maGreenBlurbs.weight,
  [ReadingType.PeakFlow]: freeTextBlurb,
  [ReadingType.SleepingMat]: freeTextBlurb,
  [ReadingType.Temperature]: freeTextBlurb,
  [ReadingType.Pulse]: freeTextBlurb,
};
export const generateNurseYellowBlurbs: TNurseBlurbYellowFnMap = {
  [ReadingType.BloodPressure]: nurseYellowBlurbs.bloodPressure,
  [ReadingType.SpO2]: nurseYellowBlurbs.spo2,
  [ReadingType.BloodGlucose]: nurseYellowBlurbs.glucose,
  [ReadingType.Weight]: nurseYellowBlurbs.weight,
  [ReadingType.PeakFlow]: freeTextBlurb,
  [ReadingType.SleepingMat]: freeTextBlurb,
  [ReadingType.Temperature]: freeTextBlurb,
  [ReadingType.Pulse]: freeTextBlurb,
};

export const maBlurbs: TMaStatusBlurbFnMap = {
  [ReadingStatus.Normal]: generateMaGreenBlurbs,
  [ReadingStatus.Risk]: generateMaYellowBlurbs,
};

export const nurseBlurbs: TNurseStatusBlurbFnMap = {
  [ReadingStatus.Normal]: generateNurseGreenBlurbs,
  [ReadingStatus.Risk]: generateNurseYellowBlurbs,
};

export const templateRoleBlurbs: TRoleBlurbFnMap = {
  [ReadingTemplateRoles.MedicalAssistant]: maBlurbs,
  [ReadingTemplateRoles.RegisterNurse]: nurseBlurbs,
};
